import { MprcBarTitle } from "components";
import { ButtonBack } from "components/buttons";
import { MprcContainer } from "components/MprcContainer";
import { MprcFormBarHeader } from "components/MprcFormBarHeader";
import { MprcPrompt } from "components/MprcPrompt";
import { useCallbackPrompt } from "hooks/useCallbackPrompt";
import React, { useState } from "react";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    title?: string;
    actions?: React.ReactNode[];
    recordChanged?: boolean;
    onBack: () => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Edição do Cabeçalho de Carrosel
 * @param props
 */
export const BaseComponentHeader: React.FC<IProps> = (props) => {
    ////////////////////////////////////////////////////////////////////////////

    const { title, actions, recordChanged = false, onBack } = props;
    const [showLostChange, setShowLostChange] = useState<boolean>(false);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(recordChanged);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    var headerItems: React.ReactNode[] = [
        <ButtonBack rounded size="large" variant="text" onClick={onBack} />
    ];

    if (title) headerItems.push(<MprcBarTitle>{title}</MprcBarTitle>);

    if (actions) headerItems = [...headerItems, ...actions];

    return (
        <MprcContainer>
            <MprcFormBarHeader actions={headerItems} />

            <MprcPrompt
                open={showPrompt}
                onConfirm={confirmNavigation}
                onCancel={cancelNavigation} />

            <MprcPrompt
                open={showLostChange}
                onCancel={() => setShowLostChange(false)}
                onConfirm={() => onBack()} />

        </MprcContainer>
    );
};
